/**
 * @generated SignedSource<<91dd011830f6a2a7f0d9e67684f8f067>>
 * @relayHash c3e1d2f1050f72df266cf46d38850c1c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8969f4f8a03c4f97fe78e9a71e972476157131fedd518964d9f6d183457b612d

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { NotificationLogsPageQuery } from './NotificationLogsPageQuery.graphql';

const node: PreloadableConcreteRequest<NotificationLogsPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "8969f4f8a03c4f97fe78e9a71e972476157131fedd518964d9f6d183457b612d",
    "metadata": {},
    "name": "NotificationLogsPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
